import { createFileRoute } from "@tanstack/react-router";

import { legalFacts } from "@/features/legal/utils/legal-facts";
import { LegalDocumentPage } from "@/features/legal/components/legal-page";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/privacy/")({
  // Out of search until `legalEntity` holds the real company details.
  staticData: { sitemap: false },
  head: () => ({ meta: pageMeta({ title: m.auth_legal_privacy(), description: m.legal_privacy_description() }) }),
  loader: () => ({ crumb: m.auth_privacy_crumb() }),
  component: () => <LegalDocumentPage title={m.auth_legal_privacy()} source={m.legal_privacy_body(legalFacts())} />,
});
